const portrait = 'portrait';
const landscape = 'landscape';

/**
 * Standard page dimensions per orientation.
 *
 * File orientation is the persisted `file.orientation` field (the file-level source of
 * truth; see documentHelper.getFileOrientation). These dimensions map an orientation to
 * the width/height applied to primary pages for that orientation.
 */
const dimensions = {
  [portrait]: { width: 816, height: 1056 },
  [landscape]: { width: 1056, height: 816 },
};

export default {
  portrait,
  landscape,
  dimensions,
};
